export default __webpack_public_path__ + "static/media/Appdynamics.5611f36b.svg";